module.exports = __webpack_public_path__ + "static/TTNormsPro-Bold-98e446cc45bb608394f29fefe6a8cb39.woff";